import { apiStudent } from '@/lib/api-manager'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'

export async function saveRequestEquivalences(
  form: MatchCoursesFormType,
  requestId?: string
) {
  const automaticEquivalences = form.automaticCourseEquivalences || []
  let equivalences =
    automaticEquivalences.map((equivalence) => ({
      ...equivalence,
      selectedByAI: true,
      equivalenceStatus: undefined
    })) || []

  equivalences = [
    ...equivalences,
    ...form.courseEquivalences.map((equivalence) => ({
      ...equivalence,
      selectedByAI: false,
      equivalenceStatus: undefined
    }))
  ]

  const body = {
    requestId: requestId,
    createStep: 'course_quivalence',
    courseEquivalenceStep: {
      courseEquivalences: equivalences
    }
  }

  return (await apiStudent.post('v1/requests', body)).data
}
